"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { Button } from '../ui-kit/button.mjs';

const buttonClasses = "self-start rounded-md";
function AdvancedOptions({
  title = "advanced options",
  openByDefault = false,
  children
}) {
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(openByDefault);
  return showAdvancedOptions ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      Button,
      {
        type: "button",
        variant: "outline",
        size: "xs",
        className: buttonClasses,
        onClick: () => setShowAdvancedOptions(false),
        children: [
          "Hide ",
          title
        ]
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-2", children })
  ] }) : /* @__PURE__ */ jsxs(
    Button,
    {
      type: "button",
      variant: "outline",
      size: "xs",
      className: buttonClasses,
      onClick: () => setShowAdvancedOptions(true),
      children: [
        "Show ",
        title
      ]
    }
  );
}

export { AdvancedOptions };
